import { render, staticRenderFns } from "./CreateActMirror.vue?vue&type=template&id=82ee6e08&scoped=true&"
import script from "./CreateActMirror.vue?vue&type=script&lang=js&"
export * from "./CreateActMirror.vue?vue&type=script&lang=js&"
import style0 from "./CreateActMirror.vue?vue&type=style&index=0&id=82ee6e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ee6e08",
  null
  
)

export default component.exports